/**
 * 用户工具函数
 * 提供一些常用的用户信息处理函数
 */

/**
 * 格式化用户名称显示
 * @param {Object} userInfo - 用户信息对象
 * @returns {string} 格式化后的用户名称
 */
export function formatUserName(userInfo) {
  if (!userInfo) return '用户'
  
  // 优先使用realName，其次使用nickname，然后使用name，最后使用username
  return userInfo.realName || userInfo.nickname || userInfo.name || userInfo.username || '用户'
}

/**
 * 格式化手机号显示
 * @param {string} phone - 手机号
 * @returns {string} 格式化后的手机号
 */
export function formatPhone(phone) {
  if (!phone) return ''
  
  // 如果是11位数字，显示为 138****8888 格式
  if (/^\d{11}$/.test(phone)) {
    return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  }
  
  return phone
}

/**
 * 格式化余额显示
 * @param {number} balance - 余额
 * @returns {string} 格式化后的余额
 */
export function formatBalance(balance) {
  if (typeof balance !== 'number') return '￥0.00'
  
  return `￥${balance.toFixed(2)}`
}

/**
 * 登录凭证管理工具
 * 用于实现"记住登录状态"功能（2天内有效）
 */

// localStorage key
const LOGIN_EXPIRE_TIME_KEY = 'loginExpireTime'

/**
 * 保存登录凭证的过期时间（当前时间 + 2天）
 */
export function saveLoginExpireTime() {
  const expireTime = Date.now() + 2 * 24 * 60 * 60 * 1000 // 2天后
  localStorage.setItem(LOGIN_EXPIRE_TIME_KEY, String(expireTime))
}

/**
 * 检查登录凭证是否有效（2天内）
 * @returns {boolean} 如果token存在且未过期，返回true；否则返回false
 */
export function isLoginValid() {
  const token = localStorage.getItem('token')
  const expireTimeStr = localStorage.getItem(LOGIN_EXPIRE_TIME_KEY)
  
  // 如果没有token，说明未登录
  if (!token) {
    return false
  }
  
  // 如果没有过期时间，说明是旧版本的登录状态，需要重新登录
  if (!expireTimeStr) {
    return false
  }
  
  const expireTime = Number(expireTimeStr)
  const now = Date.now()
  
  // 检查是否过期
  if (now > expireTime) {
    // 清除过期凭证
    clearLoginExpireTime()
    return false
  }
  
  return true
}

/**
 * 清除登录凭证的过期时间
 */
export function clearLoginExpireTime() {
  localStorage.removeItem(LOGIN_EXPIRE_TIME_KEY)
}